import { type SearchRequest } from '@searchkit/api';

import { createResponseFactory } from '~/search-domain/pipelines/event-overview/response-factory';
import { type EventOverviewESResultBody } from '~/search-domain/pipelines/event-overview/types';
import { type SearchDomainContext } from '~/search-domain/types';
import { createElasticSearchContext, createResponseFactoryContext } from '~/search-domain/utils';

export async function transformEventOverviewResponse(
  context: SearchDomainContext,
  { searchRequest, searchResponse }: { searchRequest: SearchRequest; searchResponse: EventOverviewESResultBody },
) {
  if (searchRequest.request.type === 'facet') {
    return searchResponse;
  }

  const elasticContext = createElasticSearchContext(context);

  return createResponseFactory.call(createResponseFactoryContext(context), elasticContext, searchResponse);
}
